import * as React from "react";
import { IOWidget, mk_widget, option, Options } from "../widget";

interface WaitProps<i> {
  options?:Options
  /**
   * A lazy closure 
   */
  input:() => i
  /** The closure that represents the continuation (after wait executes,resume) in the chain of widgets */
  on_done:(output_s:i) => void
  /** Time to wait */
  milliseconds:number
}
interface WaitState<_s> { }

/**
 * Don't use directly, use the [[wait]] function instead.
 * @todo maybe change it to `React.FunctionComponent` and hooks, since currently it does not use its state.
 */
class Wait<s> extends React.Component<WaitProps<s>, WaitState<s>> {
  constructor(props:WaitProps<s>, context:any) {
    super(props, context)

  }

  timer?:number

  on_new_input(new_s:() => s) {
    if (this.timer == undefined) {
      this.timer = window.setTimeout(() => {
        if (this.timer != undefined) {
          this.timer = undefined
          this.props.on_done(new_s())
        }
      }, this.props.milliseconds)
    }
  }

  /** Note: new_props will keep getting ignored if there is a timer already running */
  componentWillReceiveProps(new_props:WaitProps<s>) {
    // does not cancel current timer here
    this.on_new_input(new_props.input)
  }
  componentDidMount() {
    this.on_new_input(this.props.input)
  }

  componentWillUnmount() {
      window.clearTimeout(this.timer) /* cancel if there is a timer */
      this.timer = undefined
  }

  render() {
    return this.timer ?
      <React.Fragment
        key={option("key", this.props.options)} />
      : null
  }
}

/**
 * `wait` builds a widget that waits a given number of `milliseconds` and then yields the lazy inputted value of type `io`.
 *
 *  Only after the given time passes, the lazy input is **computed** and passed to the output.
 *
 *
 * @typeparam io Both the input type and the output type of this IOwidget.
 * @param milliseconds The time to wait until yielding the output
 * @param options general widget options
 */
export const wait = function<io>(milliseconds:number, options?:Options) : IOWidget<() => io,io> {
  return (input:() => io) => mk_widget({
    run:(on_done:(output:io) => void) =>
      React.createElement<WaitProps<io>>(Wait, { on_done, input, milliseconds, options })
  })
}
